import { render, staticRenderFns } from "./chengxinggzMb.vue?vue&type=template&id=f1bb46b8&scoped=true&"
import script from "./chengxinggzMb.vue?vue&type=script&lang=js&"
export * from "./chengxinggzMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bb46b8",
  null
  
)

export default component.exports